export const appSettingsObjectsUsingCustomEvents = "/app_settings/objects_using_custom_events";
